import React from 'react';
import { Link } from 'react-router-dom';

const FORMS_COLUMN = () => [
  {
    Header: 'Association No.',
    accessor: 'Association',
    className: 'notranslate'
  },
  {
    Header: 'Form',
    accessor: 'Form',
    className: 'notranslate'
  },
  {
    Header: 'FormId',
    accessor: 'FormId',
    className: 'notranslate'
  },
  {
    Header: 'Form Data Score',
    accessor: 'FormDataScore',
    className: 'notranslate'
  },
  {
    Header: 'Max Score Possible',
    accessor: 'MaxScorePossible',
    className: 'notranslate'
  },
  {
    Header: 'Actions',
    accessor: 'ViewSubForms',
    Cell: v => (
      <div className="d-flex">
        <Link
          to={v.value}
          className="table-link"
          onClick={() =>
            sessionStorage.setItem('metaData_categoryItem', v.value)
          }
        >
          View Sub Form
        </Link>
      </div>
    )
  }
];

export default FORMS_COLUMN;
